// extracted by mini-css-extract-plugin
export default {"login-button":"LoginPage_login-button__W6d46"};